import React, { useRef, useState, useEffect } from "react";
import { AWS_S3_URL, AWS_S3_URL_PROD } from "../../../constants";

import "./styles.scss";

// const WinnerCard = ({ name, photoUrl, drawDate, description, ticketNumber }) => {
//   return (
//     <div className='winner-card'>
//       <div className='winner-card-header'>
//         <p>Winner</p>
//       </div>

//       <div className='winner-card-body'>
//         <p className='win-date'>{drawDate}</p>
//         {/* <p className="win-title">Grand Prize Draw</p> */}
//         <div className='winner-card-image'>
//           <img src={photoUrl} alt='' />
//           <div className='winner-card-winner-name'>
//             <p>{name}</p>
//           </div>
//         </div>

//         <div className='winner-card-description-section'>
//           <div className='winner-card-description'>{description}</div>
//         </div>
//       </div>
//       <div className='winner-card-footer-container'>
//         {ticketNumber ? (
//           <div className='winner-card-footer'>
//             <p>Ticket Number: </p>
//             <p>7b132241-9db9-453-819d-81d78e38d38</p>
//           </div>
//         ) : null}
//       </div>
//     </div>
//   );
// };

const icons = {
  dreamHome: (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M34.7287 7.2716C31.4707 4.01335 26.9725 2 22 2C17.0275 2 12.5302 4.01335 9.2722 7.2716C6.0133 10.5298 4 15.0274 4 20C4 29.941 12.0577 38 22 38C26.9725 38 31.4707 35.9866 34.7287 32.7284C37.9867 29.4702 40 24.9726 40 20C40 15.0274 37.9867 10.5298 34.7287 7.2716ZM11.0839 14.041L22.0747 9.07956L32.998 14.1877L32.9224 25.7075C28.2685 28.7701 23.6767 28.9686 21.9415 28.9573C16.3723 28.9183 12.4438 26.5333 11.0056 25.5608L11.0839 14.041Z"
          fill="#004944"
        />
      </g>
      <path
        d="M32.9981 14.1877L32.9225 25.7075C28.2686 28.7701 23.6777 28.9686 21.9425 28.9574C16.3733 28.9183 12.4439 26.5333 11.0066 25.5608L11.0849 14.041L22.0748 9.07959L32.9981 14.1877Z"
        fill="#E2BCC0"
      />
      <path
        d="M34.6455 26.6676C34.6455 26.8464 34.5537 27.0126 34.4052 27.109C32.1921 28.537 29.7477 29.6115 27.1836 30.2192C25.4898 30.6202 23.7141 30.8186 21.9303 30.8158C20.1456 30.7949 18.3717 30.5713 16.6851 30.1493C14.1291 29.5081 11.6982 28.4014 9.50493 26.9442C9.35823 26.8464 9.26913 26.6787 9.27003 26.4999C9.27273 26.0737 9.75332 25.8251 10.1052 26.0695L10.4454 26.307C13.8726 28.6935 17.8758 29.8699 21.9357 29.9021C25.9956 29.9244 30.0141 28.801 33.4737 26.4594L33.8157 26.226C34.1712 25.9857 34.6491 26.2414 34.6455 26.6676Z"
        fill="#E2BCC0"
      />
      <path
        d="M28.7265 20.6523L28.7229 20.9891C28.7229 21.2504 28.5096 21.4613 28.2459 21.4613C27.9867 21.4586 27.7761 21.2448 27.7761 20.9834L27.7789 20.6915C27.7815 20.3701 27.7401 20.0934 27.6555 19.87C27.5718 19.6533 27.4548 19.4843 27.3009 19.3502C27.1335 19.2091 26.9463 19.1126 26.7267 19.0582C26.4891 18.998 26.2183 18.9674 25.9267 18.9646H25.8898C25.6396 18.9646 25.3866 18.9911 25.1382 19.04C24.9114 19.0917 24.7162 19.1811 24.5596 19.3083C24.4003 19.4382 24.2751 19.6184 24.1842 19.8476C24.0906 20.0795 24.0429 20.3771 24.0402 20.7585V20.9569C24.0375 21.2183 23.8234 21.4292 23.5624 21.4292C23.3014 21.4264 23.0898 21.2126 23.0898 20.9513L23.0925 20.6928C23.0979 19.8602 23.34 19.2244 23.8098 18.801C24.276 18.3806 24.9834 18.1667 25.9068 18.1667H25.9356L25.9545 18.1611H25.9671C26.8356 18.1667 27.5188 18.3778 27.9967 18.7871C28.4845 19.1965 28.7301 19.8252 28.7247 20.6495L28.7265 20.6523Z"
        fill="#004944"
      />
      <path
        d="M21.0309 20.5988L21.0282 20.9355C21.0282 21.1967 20.8167 21.4077 20.5503 21.4077C20.283 21.4077 20.0778 21.1939 20.0778 20.9299L20.0805 20.6406C20.0832 20.3165 20.0418 20.0384 19.9608 19.8163C19.8699 19.5914 19.7565 19.4279 19.6026 19.2993C19.4379 19.1582 19.2507 19.0646 19.0311 19.0045C18.7881 18.9445 18.5199 18.9137 18.231 18.9137H18.1941C17.9358 18.9137 17.6829 18.9402 17.4399 18.9864C17.2149 19.0353 17.0223 19.1275 16.863 19.2546C16.6983 19.3902 16.5741 19.5732 16.4868 19.7968C16.3905 20.0259 16.3428 20.3235 16.3401 20.7049V20.9033C16.3374 21.1646 16.1268 21.3756 15.8622 21.3756C15.5985 21.3756 15.3906 21.1618 15.3906 20.8977L15.3933 20.6393C15.3987 19.8093 15.6408 19.1736 16.1124 18.7475C16.5795 18.3269 17.2887 18.1131 18.222 18.1131H18.2319L18.2589 18.1104H18.267C19.1364 18.1159 19.8195 18.3241 20.2983 18.7335C20.7861 19.1456 21.0318 19.7716 21.0264 20.596L21.0309 20.5988Z"
        fill="#004944"
      />
    </svg>
  ),
  earlyBird: (
    <svg
      width="40"
      height="36"
      viewBox="0 0 40 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.88449 24.3244V23.6557H34.5837C34.6552 24.2287 34.618 24.8124 34.4746 25.3679C34.3312 25.9234 34.0848 26.4379 33.7518 26.8773C33.4189 27.3166 33.007 27.6707 32.5437 27.9159C32.0804 28.1611 31.5762 28.2918 31.0647 28.2993H9.39801C8.4663 28.2988 7.57288 27.8799 6.91406 27.1346C6.25525 26.3892 5.88493 25.3785 5.88449 24.3244ZM31.0536 8.5874C31.0536 8.5874 31.7939 11.4873 31.8491 11.6248H8.61907C8.68806 11.4921 8.94552 10.4515 9.15138 9.61943C9.2752 9.11896 9.38034 8.69396 9.41458 8.5874C9.67824 7.55558 10.2304 6.64825 10.9884 6.00147C11.7464 5.35468 12.6692 5.0033 13.6186 5H26.8496C27.7987 5.00421 28.7212 5.35594 29.479 6.00259C30.2368 6.64923 30.7892 7.55605 31.0536 8.5874ZM6.35154 10.2739C6.91332 10.1546 7.68595 9.99071 7.88985 10.0686C7.80643 10.3867 6.16071 13.756 6.16071 13.756L5.71876 13.6498C5.38766 13.5627 5.09329 13.3489 4.88546 13.0446C4.67762 12.7403 4.56907 12.3641 4.57817 11.9797C4.58726 11.5953 4.71345 11.2262 4.93538 10.9349C5.1573 10.6436 5.46136 10.448 5.7961 10.3811C5.89413 10.3709 6.10204 10.3268 6.35154 10.2739ZM32.6115 10.0186L34.2688 10.3311C34.6138 10.3935 34.9277 10.5935 35.1537 10.895C35.3796 11.1965 35.5028 11.5795 35.5008 11.9748C35.4984 12.377 35.3691 12.7649 35.1361 13.0686C34.9031 13.3724 34.5818 13.5718 34.2301 13.631C34.102 13.399 33.9405 13.1318 33.7719 12.8529C33.4636 12.3429 33.1317 11.7939 32.9374 11.3498C32.7906 10.9121 32.6652 10.4656 32.5618 10.0124C32.5701 10.0124 32.5784 10.0139 32.5866 10.0155C32.5949 10.017 32.6032 10.0186 32.6115 10.0186Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4568 12.8685C32.4332 12.8737 32.4091 12.8758 32.385 12.8748H8.0832C8.05913 12.8758 8.03503 12.8737 8.01138 12.8685L6.78497 14.956C6.19619 15.953 5.88275 17.1256 5.88449 18.3246V22.4057H34.5837V18.3246C34.682 16.2916 33.3998 14.4622 32.4568 12.8685Z"
        fill="white"
      />
      <path
        d="M9.39559 29.5498C8.72713 29.5507 8.06653 29.3867 7.45976 29.0694C6.85299 28.7521 6.31462 28.289 5.88208 27.7124V29.7811C5.88384 30.3081 6.07042 30.8128 6.40085 31.1842C6.73128 31.5557 7.17853 31.7636 7.64436 31.7623H9.27958C9.74541 31.7636 10.1927 31.5557 10.5231 31.1842C10.8535 30.8128 11.0401 30.3081 11.0419 29.7811V29.5498C10.6756 29.5511 9.74805 29.5492 9.39559 29.5498ZM33.4764 28.7811C32.3052 29.6767 30.7971 29.5611 29.4215 29.5498V29.7811C29.4215 30.3065 29.606 30.8105 29.9344 31.182C30.2629 31.5536 30.7083 31.7623 31.1727 31.7623H32.819C33.2848 31.7636 33.7321 31.5557 34.0625 31.1842C34.3929 30.8128 34.5795 30.3081 34.5813 29.7811V27.7124C34.2649 28.1321 33.8921 28.4928 33.4764 28.7811Z"
        fill="white"
      />
      <path
        d="M18.0653 20.8342C18.3635 20.8342 18.5993 20.5673 18.5993 20.2368L18.5946 20.2332L18.5977 19.8072C18.604 18.7643 18.3292 17.9724 17.7843 17.451C17.2488 16.933 16.4853 16.6697 15.5141 16.6626H15.5047L15.4751 16.6661H15.4641C14.4212 16.6661 13.628 16.9366 13.1065 17.4686C12.5788 18.0078 12.3087 18.812 12.3024 19.862L12.2993 20.189C12.2993 20.5231 12.532 20.7936 12.827 20.7936C13.1221 20.7936 13.3579 20.5267 13.361 20.1961V19.9451C13.3641 19.4625 13.4172 19.086 13.525 18.7961C13.6218 18.5133 13.7607 18.2818 13.945 18.1103C14.123 17.9494 14.3384 17.8328 14.5898 17.7709C14.8615 17.7126 15.1441 17.679 15.4329 17.679H15.4735C15.7967 17.679 16.0965 17.7179 16.3682 17.7939C16.6133 17.8699 16.8225 17.9883 17.0067 18.1669C17.1785 18.3295 17.305 18.5363 17.4064 18.8209C17.497 19.1019 17.5438 19.4537 17.5407 19.8638L17.5376 20.2297C17.5376 20.5638 17.7671 20.8342 18.0653 20.8342Z"
        fill="#819D9D"
      />
      <path
        d="M26.6652 20.8996C26.9603 20.8996 27.1992 20.6327 27.1992 20.3022L27.1976 20.2986L27.2007 19.8726C27.207 18.8297 26.9322 18.0343 26.3873 17.5164C25.8533 16.9984 25.0898 16.7315 24.1186 16.7245H24.1046L24.0843 16.7315H24.0515C23.0195 16.7315 22.2294 17.002 21.7079 17.534C21.1833 18.0696 20.9132 18.8739 20.907 19.9274L20.9038 20.2544C20.9038 20.585 21.1396 20.8554 21.4316 20.859C21.7235 20.859 21.9624 20.5921 21.9656 20.2615V20.0105C21.9687 19.5279 22.0218 19.1514 22.1264 18.858C22.2279 18.5681 22.3684 18.3401 22.5464 18.1757C22.7212 18.0148 22.9398 17.9017 23.1928 17.8363C23.4707 17.7744 23.7533 17.7409 24.0328 17.7409H24.0734C24.3997 17.7444 24.7026 17.7833 24.968 17.8593C25.2131 17.9282 25.4223 18.0502 25.6097 18.2287C25.7815 18.3984 25.9126 18.6123 26.0063 18.8863C26.1 19.1691 26.1468 19.5191 26.1437 19.9257L26.1406 20.2951C26.1406 20.6257 26.3763 20.8961 26.6652 20.8996Z"
        fill="#819D9D"
      />
    </svg>
  ),
  weekDraws: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.251 4.5C18.7257 4.49962 20.1599 4.98217 21.3344 5.8739C22.5089 6.76562 23.3591 8.01745 23.755 9.438L23.833 9.7455L26.638 9.045C26.843 8.99397 27.0565 8.98682 27.2645 9.02403C27.4724 9.06125 27.6702 9.14197 27.8448 9.26093C28.0194 9.37988 28.1669 9.53438 28.2777 9.71431C28.3884 9.89423 28.4599 10.0955 28.4875 10.305L28.501 10.5V13.215C29.347 14.0254 30.0401 14.9817 30.547 16.038L30.754 16.5H31.501C31.8684 16.5 32.223 16.6349 32.4975 16.8791C32.7721 17.1232 32.9475 17.4596 32.9905 17.8245L33.001 18V22.5C33.001 22.7469 32.9401 22.99 32.8237 23.2077C32.7072 23.4254 32.5388 23.611 32.3335 23.748L32.1715 23.841L30.4195 24.7185C29.7035 26.107 28.6643 27.303 27.3895 28.206L27.001 28.467V30C27.0009 30.3674 26.866 30.722 26.6219 30.9966C26.3778 31.2711 26.0414 31.4465 25.6765 31.4895L25.501 31.5H21.001C20.6336 31.5 20.279 31.3651 20.0044 31.1209C19.7299 30.8768 19.5545 30.5404 19.5115 30.1755L19.501 30H18.001C18.0009 30.3674 17.866 30.722 17.6219 30.9966C17.3778 31.2711 17.0414 31.4465 16.6765 31.4895L16.501 31.5H12.001C11.6336 31.5 11.279 31.3651 11.0044 31.1209C10.7299 30.8768 10.5545 30.5404 10.5115 30.1755L10.501 30V28.467C9.41691 27.7747 8.48054 26.8748 7.74581 25.819C7.01108 24.7633 6.49251 23.5726 6.21998 22.3155C5.33525 22.0526 4.55274 21.5241 3.97854 20.8015C3.40433 20.0789 3.0662 19.1972 3.00998 18.276L3.00098 18V17.25C3.0014 16.8677 3.1478 16.5 3.41025 16.2219C3.6727 15.9439 4.03141 15.7766 4.41307 15.7542C4.79473 15.7318 5.17055 15.856 5.46373 16.1014C5.7569 16.3468 5.94532 16.6949 5.99048 17.0745L6.00098 17.25V18C6.00298 18.224 6.04798 18.4315 6.13598 18.6225C6.36457 17.2719 6.87516 15.9847 7.63449 14.8447C8.39382 13.7047 9.38484 12.7374 10.543 12.006C10.4365 11.0617 10.5307 10.1056 10.8193 9.20024C11.1078 8.29486 11.5843 7.46061 12.2175 6.75208C12.8507 6.04354 13.6264 5.47668 14.4938 5.08859C15.3612 4.70051 16.3007 4.49993 17.251 4.5ZM24.001 16.5C23.6031 16.5 23.2216 16.658 22.9403 16.9393C22.659 17.2206 22.501 17.6022 22.501 18C22.501 18.3978 22.659 18.7794 22.9403 19.0607C23.2216 19.342 23.6031 19.5 24.001 19.5C24.3988 19.5 24.7803 19.342 25.0616 19.0607C25.3429 18.7794 25.501 18.3978 25.501 18C25.501 17.6022 25.3429 17.2206 25.0616 16.9393C24.7803 16.658 24.3988 16.5 24.001 16.5ZM17.251 7.5C16.3424 7.5 15.4647 7.82985 14.7811 8.42826C14.0974 9.02667 13.6543 9.85294 13.534 10.7535C14.2608 10.5844 15.0047 10.4994 15.751 10.5H20.8165L20.9215 10.4745C20.7436 9.63294 20.2818 8.87811 19.6135 8.33655C18.9453 7.795 18.1111 7.49964 17.251 7.5Z"
        fill="#F8F4F0"
      />
    </svg>
  ),
};

const WinnerCard = (props) => {
  const winner = props.winner;

  const awsURL = props.production ? AWS_S3_URL_PROD : AWS_S3_URL;

  const prizeIcon = (prizeType) => {
    switch (prizeType) {
      case "dreamHome":
        return icons.dreamHome;
      case "earlyBird":
        return icons.earlyBird;
      case "weekDraws":
        return icons.weekDraws;
      default:
        return icons.dreamHome;
    }
  };

  const formatedDate = (date) => {
    return `${new Date(date).getDate()} ${new Date(date).toLocaleString("en", {
      month: "long",
    })}, ${new Date(date).getFullYear()}`;
  };

  const getWinnerPhotoUrl = () => {
    const string = winner.winnerPhotoUrl
      ? "winnersPhotosPeople/" + winner.winnerPhotoUrl
      : "winnersPhotos/" + winner.photoUrl;
    return awsURL + string + ".jpg";
  };

  const htmlToText = (html) => {
    if (!html) return '';

    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent.replace(/\s+/g, ' ').trim() || '';
  };

  const clampText = (text, container, maxLines) => {
    if (!text) return '';

    const style = getComputedStyle(container);
    const lineHeight = parseFloat(style.lineHeight);
    const maxHeight = Math.ceil(lineHeight * maxLines);

    let left = 0;
    let right = text.length;
    let result = text;
    container.textContent = text;

    const prevHeight = container.style.height;
    const prevMinHeight = container.style.minHeight;

    container.style.height = 'auto';
    container.style.minHeight = '0';

    container.textContent = text;

    if (container.scrollHeight <= maxHeight) {
      container.style.height = prevHeight;
      container.style.minHeight = prevMinHeight;
      return text;
    }

    while (left <= right) {
      const mid = Math.floor((left + right) / 2);
      container.textContent = text.slice(0, mid) + '…';

      if (container.scrollHeight > maxHeight) {
        right = mid - 1;
      } else {
        result = text.slice(0, mid) + '…';
        left = mid + 1;
      }
    }

    return result;
  };

  const ClampedText = ({ html, desktopLines = 8, mobileLines = 7 }) => {
    const ref = useRef(null);
    const [text, setText] = useState('');

    useEffect(() => {
      if (!ref.current) return;

      const plainText = htmlToText(html);
      const isMobile = window.innerWidth < 1000;
      const lines = isMobile ? mobileLines : desktopLines;
      const clamped = clampText(plainText, ref.current, lines);
      setText(clamped);
    }, [html, desktopLines, mobileLines]);

    return (
      <div ref={ref} className="winner-slide__text">
        {text}
      </div>
    );
  };

  return (
    <div className="winner-slide">
      <div className="winner-slide__head">
        <div className="winner-slide__head-prize">
          {prizeIcon(winner.prizeType)}
          {winner.prizeTitle}
        </div>
        <div className="winner-slide__head-title">{winner.prizeLabel}</div>
        <div className="winner-slide__head-label">
          {winner.prizeType === "weekDraws" ? "WINNERS" : "WINNER"}
        </div>
      </div>
      <div className="winner-slide__photo">
        <img
          decoding="async"
          loading="lazy"
          src={getWinnerPhotoUrl()}
          alt={winner.name ? `Winner - ${winner.name}` : "Winner"}
        />
      </div>
      <div className="winner-slide__body">
        {winner.photoUrl && winner.winnerPhotoUrl && (
          <div className="winner-slide__photo-prize">
            <img
              decoding="async"
              loading="lazy"
              src={awsURL + "winnersPhotos/" + winner.photoUrl + ".jpg"}
              alt={winner.prizeTitle ? `${winner.prizeTitle}` : "Prize"}
            />
          </div>
        )}
        <div className="winner-slide__content">
          <div className="winner-slide__info">
            <div className="winner-slide__info-name">{winner.name}</div>
            <div className="winner-slide__info-data">
              {formatedDate(winner.drawDate)}
            </div>
          </div>
          <div className="winner-slide__textblock">
            {winner.sex ? (
              <span className="winner-slide__textblock-label">
                {winner.sex === "female" ? "she" : "he"} took the cash!
              </span>
            ) : null}
            {winner.description && <ClampedText html={winner.description} desktopLines={7} mobileLines={8} />}
          </div>
        </div>
        {winner.ticket && (
          <p className="winner-slide__ticket">
            WINNING TICKET NUMBER <span>{winner.ticket}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default WinnerCard;
